import 'bootstrap-ie11/scss/bootstrap-ie11.scss';
import '../../sass/outer_layout.scss';
import '../../sass/registration.scss';
import '../components/polyfill';
import 'ie11-custom-properties';
import 'element-qsa-scope';
import '../components/menu';
import '@fortawesome/fontawesome-free/js/all.min';
import {
    ajaxPrefilter,
    onAjaxComplete,
    checkTargetHostname,
} from '@frontend/components/utils';
import { delegate } from '@shared/event-helpers';

delegate(document, 'click', 'a', (event) => {
    !checkTargetHostname(event.target.hostname) && event.preventDefault();
});

delegate(document, 'submit', 'form', (event) => {
    !checkTargetHostname(new URL(event.target.action).hostname) &&
        event.preventDefault();
});

ajaxPrefilter();
onAjaxComplete();
